import {
  ExpandedDetailsSection,
  Flex,
  TestLineageNavButton,
} from '@elementary/common-ui/components';
import { CondensedTable } from '@elementary/common-ui/components/Table';
import { TestResult } from '@elementary/common-ui/types';
import { Stack, Typography } from '@mui/material';
import AdditionalActionsButton from './AdditionalActionsButton';
import OpenTestRunsButton from './OpenTestRunsButton';

const DbtExpandedRow = ({
  rowData,
  showWidgetButtons,
}: {
  rowData: TestResult;
  showWidgetButtons: boolean;
}) => {
  const { test_results: testResults, metadata } = rowData || {};
  const { display_name: displayName, results_sample: resultsSample } =
    testResults || {};

  return (
    <Stack sx={{ gap: 2 }}>
      <Flex sx={{ justifyContent: 'space-between' }}>
        <Typography sx={{ fontWeight: 500 }}>{displayName}</Typography>
        {showWidgetButtons && (
          <Flex gap={1}>
            <OpenTestRunsButton urlParam={metadata.elementary_unique_id} />
            {!!metadata.model_unique_id && (
              <TestLineageNavButton
                modelId={metadata.model_unique_id}
                testName={metadata.test_name}
              />
            )}
            <AdditionalActionsButton
              elementaryUniqueId={rowData.metadata.elementary_unique_id}
            />
          </Flex>
        )}
      </Flex>

      <CondensedTable data={resultsSample || []} />
      <ExpandedDetailsSection data={rowData} />
    </Stack>
  );
};

export default DbtExpandedRow;
